import React from "react";
import { Button, Modal } from "react-bootstrap";
import './PendingVerificationDialog.css';

export default function PendingVerificationDialog(props) {
    return (
        <Modal id="cePendingVerification" show={props.show} onHide={props.handleClose} centered >
            <Modal.Header closeButton>
                <Modal.Title>
                    {<div className="content-title">
                        <span>{props.intl.formatMessage({ id: "header_pending_verification" })}</span>
                    </div>}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <span>{props.intl.formatMessage({ id: "pending_verification_dialog_message" })}</span>
                <div className="errMsg">{<span>{props.intl.formatMessage({ id: "errCode_10100" })}</span>}</div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={props.handleClose}>{props.intl.formatMessage({ id: "header_cancel" })}</Button>
                <Button variant="primary" onClick={PendingVerification.bind(this, props)}>{props.intl.formatMessage({ id: "send_button" })}</Button>
            </Modal.Footer>
        </Modal>
    );
};

// 確認メール送信処理
function PendingVerification(props) {
    fetch(process.env.REACT_APP_CE_PENDING_VERIFICATION_MAIL, {
        method: "POST",
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ userId: props.ceId }),
    }).then(res => {
        if (!res.ok) {
            // リクエスト失敗時'errCode_10100'の内容を表示する
            document.getElementById("cePendingVerification").getElementsByClassName("errMsg")[0].style.visibility = 'visible';
            return;
        } else {
            props.handleClose();
            props.displaySnackbar();
        }
    }).catch((e) => {
        // #TBD:エラーオブジェクトからerrCodeの値を取得する設定
        // let id = 'errCode_' + e.errCode;
        // document.getElementById("cePendingVerification").getElementsByClassName("errMsg")[0].innerHTML = props.intl.formatMessage({ id: id });
        document.getElementById("cePendingVerification").getElementsByClassName("errMsg")[0].style.visibility = 'visible';
        throw e;
    });
}